/**
 * 日本語などの変換中のキーかを返す。変換を確定する Enter や、変換を取り消す Esc を、送信や閉じる操作として扱わないために使う。
 * Safari は変換を確定した時点で isComposing が false になることがあるので、keyCode 229（変換中のキー）も見る
 */
export const isComposingKey = ({ isComposing, keyCode }: { isComposing: boolean; keyCode: number }): boolean =>
  isComposing || keyCode === 229
